export function roundWithDecimals(value) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
}